module.exports = __webpack_public_path__ + "static/img/product_banner03.5696249.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/product_banner03.png
// module id = BFFh
// module chunks = 0